export function getIconColor(isFocused?: boolean, isLg?: boolean) {
  if (isLg) {
    return isFocused ? 'neutral30' : 'neutral20';
  }
  return isFocused ? 'accentSecondary10' : 'neutral30';
}
